var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    viewBox: "0, 0, 500, 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.231,116.197 C290.437,116.197 307.078,126.64 316.269,142.03 L370.407,142.091 L370.407,113.022 C370.407,102.243 361.643,93.48 350.834,93.48 L148.97,93.48 C138.191,93.48 129.459,102.243 129.459,113.022 L129.52,141.846 L226.192,141.908 C235.444,126.579 252.024,116.197 271.231,116.197",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.085,84.258 L162.131,84.258 L160.054,90.732 L181.581,90.732 z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.01,80.808 L318.101,80.808 L313.857,90.793 L345.888,90.793 z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.803,73.388 L220.726,73.388 L208.757,90.915 L289.796,90.915 L278.803,73.388 z M259.933,87.342 L239.322,87.342 L239.322,77.388 L259.933,77.388 L259.933,87.342 z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.048,147.221 C322.04,153.816 323.811,161.083 323.811,168.809 C323.811,197.847 300.269,221.42 271.2,221.42 C242.131,221.42 218.589,197.877 218.589,168.809 C218.589,161.083 220.329,153.816 223.352,147.19 L129.428,147.19 L129.428,226.458 C129.428,237.237 138.13,246 148.94,246 L350.804,246 C361.613,246 370.376,237.237 370.376,226.458 L370.437,147.221 L319.048,147.221 z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.903,151.526 C299.078,150.06 298.04,148.686 296.91,147.373 C290.773,139.984 281.582,135.159 271.2,135.159 C260.818,135.159 251.627,139.953 245.49,147.312 C244.36,148.656 243.353,150.03 242.436,151.526 C239.322,156.595 237.49,162.457 237.49,168.809 C237.49,187.374 252.574,202.458 271.2,202.458 C289.735,202.458 304.849,187.404 304.849,168.809 C304.849,162.457 303.017,156.595 299.903,151.526",
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0, 0, 1, 254, 349)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -173.727,
    y: -14.812,
    fontFamily: "Sathu",
    fontSize: 72,
    fill: "#DDDDDD"
  }, "Image Not "), /*#__PURE__*/React.createElement("tspan", {
    x: -105.4,
    y: 80.588,
    fontFamily: "Sathu",
    fontSize: 72,
    fill: "#DDDDDD"
  }, "Found")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFound);
export default __webpack_public_path__ + "static/media/image_not_found.8a5ae50617dcb1d649a893ad96178ac2.svg";
export { ForwardRef as ReactComponent };